var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 539 62",
    style: {
      enableBackground: "new 0 0 539 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#94969A;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALFRED_H_KNIGHT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,52l17.2-39.5h6.4L42.5,52h-7.3l-4-9.5H12.8L8.7,52H1.7z M15.3,36.4h13.5L22,20.8L15.3,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.2,52V12.8h6.9v32.9h20.6V52H49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.9,52V12.8h29.2v6.3H90.8v10.7h19.8v6.3H90.8V52H83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6,52V12.8h17.5c4.5,0,8.1,1.1,10.7,3.4c2.6,2.3,4,5.6,3.9,9.1c0.1,2.8-0.8,5.5-2.5,7.6 c-1.8,2.1-4.2,3.5-6.9,4.2L153.9,52h-8.1L136,38.3h-8.5V52H120.6z M127.5,32.2h10.1c2.1,0.1,4.2-0.5,5.9-1.8 c1.5-1.2,2.3-3,2.2-4.9c0.1-1.8-0.7-3.6-2.1-4.8c-1.8-1.2-3.9-1.8-6-1.7h-10L127.5,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.1,52V12.8h29.1v6.1H168v10.3h19.7v6.1H168v10.6h22.4V52H161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.6,52V12.8h14.6c2.9,0,5.7,0.5,8.4,1.5c2.5,0.9,4.7,2.3,6.6,4.1c1.8,1.8,3.3,3.9,4.2,6.2 c2,5,2,10.5,0,15.5c-1,2.3-2.4,4.5-4.2,6.2c-1.9,1.8-4.1,3.2-6.6,4.1c-2.7,1-5.6,1.5-8.5,1.5H198.6z M205.5,45.7h7.7 c3.7,0.2,7.2-1.2,9.9-3.7c2.5-2.6,3.9-6,3.7-9.6c0.1-3.6-1.2-7-3.8-9.6c-2.6-2.5-6.2-3.9-9.9-3.7h-7.7V45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.2,52V12.8h6.9v16.3h18.7V12.8h6.9V52h-6.9V35.5H266V52H259.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.5,52V12.8h6.9v19.7L344,12.8h8.5l-16.3,16.9l17,22.3h-8.3l-13.4-17.6l-6.1,6.3V52H318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.1,52V12.8h6.4l21,27.1V12.8h6.8V52h-5.8l-21.6-27.9V52H359.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.7,52V12.8h6.9V52H403.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.3,32.4c0-2.7,0.5-5.3,1.5-7.8c1-2.4,2.4-4.6,4.2-6.5c1.8-1.9,4-3.4,6.4-4.4c2.6-1.1,5.3-1.6,8.1-1.6 c2.9-0.1,5.7,0.4,8.4,1.3c2.4,0.9,4.7,2.3,6.7,4l-4.4,5.2c-1.5-1.3-3.2-2.4-5-3.2c-1.9-0.7-4-1.1-6-1c-2.3,0-4.5,0.6-6.5,1.9 c-2,1.3-3.5,3-4.6,5.1c-1.1,2.2-1.7,4.6-1.6,7c0,2.5,0.5,5,1.6,7.2c1.1,2.1,2.7,3.8,4.7,5c2.1,1.2,4.5,1.9,7,1.8 c3.4,0.1,6.7-1,9.5-3v-7.4h-10v-6H456v16.5c-4.5,4-10.3,6.2-16.4,6.1c-3.7,0.1-7.4-0.9-10.6-2.7c-3-1.7-5.5-4.2-7.2-7.3 C420.1,39.5,419.3,36,419.3,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.9,52V12.8h6.9v16.3h18.7V12.8h6.9V52h-6.9V35.5h-18.7V52H464.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.6,19.2v-6.4h31.8v6.4H524V52h-6.9V19.2H504.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.c3dda865b5b527c9144826548bc778b6.svg";
export { ForwardRef as ReactComponent };